<template>
<v-modal width="27em"
  :modelValue="modelValue"
  @close="$emit('update:modelValue', false)">

  <template #content>
    <div class="v-modal__title"
      v-if="title">
      {{ title }}
    </div>
    <div class="v-modal__text"
      v-if="message"
      v-html="message">
    </div>
  </template>

  <template #buttons>
    <button class="button-secondary"
      v-if="labelDiscard"
      @click="discard">
      {{ labelDiscard }}
    </button>
    <button class="button-primary"
      v-if="labelConfirm"
      @click="confirm">
      {{ labelConfirm }}
    </button>
  </template>

</v-modal>
</template>

<script>
import vModal from './v-modal.vue'
export default {
  components: { vModal },
  props: {
    modelValue: { type: Boolean, required: false, default: false },
    title: { type: String, required: false, default: undefined },
    message: { type: String, required: true },
    labelConfirm: { type: String, required: false, default: "✓" },
    labelDiscard: { type: String, required: false, default: "✕" },
  },
  data() {
    return {
      promise: null,
      resolve: null,
      reject: null,
    }
  },
  created() { 
    this.promise = new Promise((res,rej) => {
      this.resolve = res
      this.reject = rej
    })
  },
  methods: {
    confirm() { 
      this.resolve(true) 
    },
    discard() { 
      this.resolve(false)
    }
  }
}
</script>